var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 20.0001C7.12436 20.0001 5.3335 21.7911 5.3335 24.0001C5.3335 26.2093 7.12436 28.0001 9.3335 28.0001C11.5426 28.0001 13.3335 26.2093 13.3335 24.0001C13.3335 21.7911 11.5426 20.0001 9.3335 20.0001Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 20.0001C20.4573 20.0001 18.6665 21.7911 18.6665 24.0001C18.6665 26.2093 20.4573 28.0001 22.6665 28.0001C24.8757 28.0001 26.6665 26.2093 26.6665 24.0001C26.6665 21.7911 24.8757 20.0001 22.6665 20.0001Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 22.6668H13.3335",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 17.3335C26.0577 15.6968 21.2977 14.6668 15.9998 14.6668C10.7019 14.6668 5.94196 15.6968 2.6665 17.3335",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 16.0001L8.02282 6.26135C8.30445 4.23909 10.7404 3.30089 12.3537 4.59331C14.6665 6.6668 17.3332 6.6668 19.646 4.59331C21.2593 3.30089 23.6952 4.23909 23.9769 6.26135L25.3332 16.0001",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3);
export default __webpack_public_path__ + "static/media/svg3.bccfa1d28958ca6a01882c93a71b2319.svg";
export { ForwardRef as ReactComponent };